import { categoryData } from '../categoryData'
import { countryRegionData } from '../countryRegionData'
import {
  EMAIL_REGEX,
  FREE_TEXT_REGEX,
  PHONE_NUMBER_REGEX,
  SUBDOMAIN_REGEX,
} from '../regexConstants'

const countries = countryRegionData.map(countryRegion => ({
  label: countryRegion.countryName,
  value: countryRegion.countryName,
}))

const categories = categoryData.map(category => ({
  label: category.categoryName,
  value: category.categoryName,
}))

export default [
  {
    name: 'category',
    label: 'Category',
    errorMessage: 'Please select category',
    required: true,
    type: 'select',
    options: categories,
    pattern: FREE_TEXT_REGEX,
  },
  {
    name: 'name',
    label: 'Organization/School Name:',
    errorMessage: 'Enter your organization/school name',
    required: true,
    type: 'text',
    pattern: FREE_TEXT_REGEX,
  },
  {
    name: 'site_name',
    label: 'Site Name:',
    errorMessage: 'Enter a valid site name',
    required: true,
    type: 'text',
    pattern: SUBDOMAIN_REGEX,
  },
  {
    name: 'phone',
    label: 'Phone Number:',
    errorMessage: 'Enter your phone number',
    required: true,
    type: 'tel',
    pattern: PHONE_NUMBER_REGEX,
  },
  {
    name: 'email',
    label: 'Organization/School Email',
    errorMessage: 'Enter your organization/school email',
    required: true,
    type: 'email',
    pattern: EMAIL_REGEX,
  },
  {
    name: 'address',
    label: 'Address:',
    errorMessage: 'Enter your address',
    required: true,
    type: 'textarea',
    pattern: FREE_TEXT_REGEX,
  },
  {
    name: 'country',
    label: 'Country:',
    errorMessage: 'Select country',
    required: true,
    type: 'select',
    options: countries,
    pattern: FREE_TEXT_REGEX,
  },
  {
    name: 'state',
    label: 'State:',
    errorMessage: 'Select state',
    required: true,
    type: 'select',
    options: [],
    pattern: FREE_TEXT_REGEX,
  },
  {
    name: 'city',
    label: 'City:',
    errorMessage: 'Enter city',
    required: true,
    type: 'text',
    pattern: FREE_TEXT_REGEX,
  },
  {
    name: 'postal_code',
    label: 'Postal Code:',
    errorMessage: 'Enter your postal code',
    required: true,
    type: 'text',
    pattern: FREE_TEXT_REGEX,
  },
]
